export enum AuthRoutes {
  WELCOME = 'welcome',
  LOGIN = 'login',
  REGISTER = 'register',
  RESET_PASSWORD = 'reset-password',
  RESET_PASSWORD_SENT = 'reset-password-sent'
}
